import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { RatingChoice } from './new-service.model';
import {
  FormArray,
  FormGroup,
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { DynamicServices } from 'src/app/features/ayen-services/services/dynamic-services/dynamic-services.service';
import { AlertBoxComponent } from 'src/app/shared/components/alert-box/alert-box.component';
import { ChangeCategoryComponent } from 'src/app/features/ayen-services/components/change-category/change-category.component';
import { ConfirmationBoxComponent } from 'src/app/shared/components/confirmation-box/confirmation-box.component';
import { Select, Store } from '@ngxs/store';
import {
  AddService,
  ChangeCategoriesRatio,
  ChangeTermCategory,
  GetServiceById,
  HandleError,
  RedistrbuteRatios,
  UpdateCategory,
  UpdateService,
} from '../../state/service-action';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';
import { NewServicesState } from '../../state/ayen-service.state';
import { AddCategoriesComponent } from '../../components/add-categories/add-categories.component';
import { ServiceCredentialsComponent } from '../../components/service-credentials/service-credentials.component';
import { NgSelectComponent } from '@ng-select/ng-select';
import { SettingServicesService } from '../../services/setting-services/setting-services.service';
import { CompletionStatusComponent } from 'src/app/shared/components/completion-status/completion-status.component';
import { CategoriesService } from '../../services/categories/categories.service';
import { IndexationComponent } from '../../components/indexation/indexation.component';

@Component({
  selector: 'app-new-service',
  templateUrl: './new-service.component.html',
  styleUrls: ['./new-service.component.scss'],
})
export class NewServiceComponent implements OnInit, OnDestroy {
  addServiceFormGroup: UntypedFormGroup;
  saveDialogRef: MatDialogRef<AlertBoxComponent>;
  addCategoryRef: MatDialogRef<AddCategoriesComponent>;
  changeCategoryRef: MatDialogRef<ChangeCategoryComponent>;
  confirmationDialogRef: MatDialogRef<ConfirmationBoxComponent>;
  credentialsDialogRef: MatDialogRef<ServiceCredentialsComponent>;
  statusRef: MatDialogRef<CompletionStatusComponent>;
  editIndexationRef: MatDialogRef<IndexationComponent>;

  credentials = {
    academic_major: [],
    years_of_experience: [],
    certificates: [],
    qualification_choice: [],
    category: [],
    inspector_type: [],
    expertise_areas: [],
    special_qualification_tags: [],
  };
  confirmMsg: string = '';
  successImg: boolean = true;
  serviceId: any;
  serviceDetails: any;
  addStatus: boolean;
  alertmsg: boolean;
  message: string = '';
  isActive: boolean = true;
  isActiveExsep: boolean = false;
  allow_inspector_to_skip_terms: boolean = false;
  is_droplist: boolean = false;
  backUrl: string = '/pages/services/list';
  choicesList = [];
  statusCustomChoices = [];
  ratingChoices: RatingChoice[] = [];
  showRatingPanel = false;
  buildingDetails = [];
  initBuildingDetails: string[] = [];
  initAllowanceFields = [];
  allowanceFieldsValues = [];
  @Select(NewServicesState.getServiceById) serviceById$: Observable<any>;
  @Select(NewServicesState.serverError) serverError$: Observable<string>;
  @Select(NewServicesState.getAdditionList) AdditionsList$: Observable<any>;
  serviceByIdSubscribtion: Subscription;
  errorMsg: boolean = false;
  selectedAccordion: number;
  allowanceFields: any[];
  @ViewChild('custonCompleteDisplay') custonCompleteDisplay: NgSelectComponent;
  @ViewChild('showTerms') showTerms: NgSelectComponent;
  @ViewChild('selectMeasurement') selectMeasurement: NgSelectComponent;

  private onScroll = (event: any) => {
    if (
      this.custonCompleteDisplay?.isOpen ||
      this.showTerms?.isOpen ||
      this.selectMeasurement?.isOpen
    ) {
      const isScrollingInScrollHost =
        (event.target.className as string).indexOf('ng-dropdown-panel-items') >
        -1;
      if (isScrollingInScrollHost) {
        return;
      }
      this.custonCompleteDisplay?.close();
      this.showTerms?.close();
      this.selectMeasurement?.close();
    }
  };

  additionList: any[] = [];
  config: any;
  currentItemsPerPage: number;
  page: number = 1;
  totalRecords: any = 0;
  page_size: number = 20;
  payload: { page: number; query: string; page_size: number } = {
    page: this.page,
    query: '',
    page_size: this.page_size,
  };
  dynamicServicesItems = new BehaviorSubject({});
  additionData = this.dynamicServicesItems.asObservable();
  initAdditions: any[] = [];
  status_payload: { page: any; query: string; page_size: any };
  status_config: any;
  mainTitle: string;
  unitMeasurments: any[] = [];
  measurementPage: any;
  measurement_page_count: any;
  measurementParams: any;
  tempIndexationForm: any;
  termsInCategories: FormArray<any>;
  notesDisplayChoices: any[] = [];

  constructor(
    private formBuilder: UntypedFormBuilder,
    private router: Router,
    private dynamicService: DynamicServices,
    private dialog: MatDialog,
    private activatedRoute: ActivatedRoute,
    private store: Store,
    private settingServices: SettingServicesService,
    private categoriesService: CategoriesService
  ) {
    this.config = {
      id: 'additionList',
      itemsPerPage: 20,
      currentPage: this.page,
      totalItems: this.totalRecords,
      pageCount: 0,
    };
  }

  ngOnDestroy(): void {
    this.serviceByIdSubscribtion?.unsubscribe();
    window.removeEventListener('scroll', this.onScroll, true);
  }

  ngOnInit(): void {
    this.createForm();
    this.getDynamicServicesChoices();
    this.getBuildingData();
    this.getNotesDisplayChoices();
    this.setPaginationConfig('status_config');
    this.getStatusCustomDisplay();
    this.getunitMeasurments({ page: '1' });
    if (this.router.url.includes('new')) {
      this.mainTitle = 'إضافة';
      this.addStatus = true;
      this.confirmMsg = 'تم الحفظ بنجاح';
    } else if (this.router.url.includes('edit')) {
      this.mainTitle = 'تعديل';
      this.addStatus = false;
      this.serviceId = this.activatedRoute.snapshot.params.id;
      this.getServiceById();
      this.confirmMsg = 'تم الحفظ بنجاح';
    }
    this.serverError$.subscribe((data) => {
      if (data.length !== 0) {
        this.successImg = false;
        this.confirmMsg = data;
        this.showAlertBox();
      }
    });
    window.addEventListener('scroll', this.onScroll, true);
  }

  createForm() {
    this.addServiceFormGroup = this.formBuilder.group({
      name: ['', Validators.required],
      explantion_txt: [''],
      order_pool_delay_minutes: [null],
      is_active: [true],
      is_active_for_exsep: [this.isActiveExsep],
      show_terms: [null, Validators.required],
      completion_status: [null, Validators.required],
      categories: this.formBuilder.array([]),
      building_data_to_show: [null],
      service_credentials: [this.credentials],
      default_notes_display: [null]
    });
  }
  isValidExcept(form: FormGroup, excludeKeys: string[] = []): boolean {
    return Object.keys(form.controls)
      .filter((key) => !excludeKeys.includes(key))
      .every((key) => form.get(key)?.valid);
  }
  createIndextionForm() {
    return this.formBuilder.group({
      is_active: [true, Validators.required],
      name: ['', Validators.required],
      description: ['', Validators.required],
      unit_cost: ['', Validators.required],
      unit_of_measurement: [null, Validators.required],
    });
  }

  createItem(): FormGroup {
    return this.formBuilder.group({
      name: ['', Validators.required],
      description: ['', Validators.required],
      ratio: [0, Validators.required],
      repairing_cost: [0, Validators.required],
      id: [null],
      is_decision_driver: [false],
      indexations: this.createIndextionForm(),
    });
  }

  getUnitName(id: number): string {
    const unit = this.unitMeasurments.find((u) => u.id === id);
    return unit ? unit.name : '';
  }

  setPaginationConfig(config) {
    this[config] = {
      id: config,
      itemsPerPage: 20,
      currentPage: this.page,
      totalItems: this.totalRecords,
      pageCount: 0,
    };
  }

  createCategory(): FormGroup {
    return this.formBuilder.group({
      name: ['', Validators.required],
      id: [null],
      ratio: [0],
      terms: this.formBuilder.array([]),
    });
  }

  categories(): FormArray {
    this.termsInCategories = this.addServiceFormGroup.get(
      'categories'
    ) as FormArray;
    return this.termsInCategories;
  }

  terms(categoryIndex): FormArray {
    return this.categories().at(categoryIndex).get('terms') as FormArray;
  }

  addCategory(): void {
    this.categories().push(this.createCategory());
  }

  addItem(categoryIndex): void {
    this.terms(categoryIndex).push(this.createItem());
  }

  addIndexationItem(categoryIndex, termIndex, termId, event) {
    const term = this.terms(categoryIndex).at(termIndex) as FormGroup;
    const indexations = term.get('indexations') as FormGroup;
    if (indexations.valid) {
      let data = indexations.value;
      data = { ...data, term: termId };
      this.categoriesService.createIndexation(data, event?.buttonId).subscribe(
        (data) => {
          this.serviceDetails?.categories[categoryIndex]?.terms[
            termIndex
          ]?.indexations.push(data);
          indexations.reset();
          indexations.get('is_active').setValue(true);
          this.successImg = true;
          this.confirmMsg = 'تم الحفظ بنجاح';
          this.showAlertBox();
        },
        (error) => {}
      );
    }
  }

  getFilteredUnits(allowedIds: number[]) {
    return this.unitMeasurments.filter((u) => allowedIds.includes(u.id));
  }

  deleteItem(categoryIndex, index) {
    this.terms(categoryIndex).removeAt(index);
  }

  isActiveValueChanged(event) {
    this.addServiceFormGroup.get(event.labelEn).setValue(event.value);
  }
  isActiveDecisionValueChanged(event, categoryIndex, index) {
    this.terms(categoryIndex)
      .at(index)
      .get(event.labelEn)
      .setValue(event.value);
  }

  saveCategory(categoryIndex) {
    if (!this.areTermsValid(categoryIndex)) {
      this.errorMsg = true;
      this.selectedAccordion = categoryIndex;
      this.message = 'يرجى تعبئة جميع الخانات';
      return;
    }
    this.store.dispatch(new HandleError('')).subscribe(() => {});
    const category =
      this.addServiceFormGroup.get('categories').value[categoryIndex];
    this.store
      .dispatch(new UpdateCategory(category.id, category, categoryIndex))
      .subscribe(
        (data) => {
          this.successImg = true;
          this.errorMsg = false;
          this.confirmMsg = 'تم الحفظ بنجاح';
          this.showAlertBox();
        },
        (error) => {
          try {
            this.successImg = false;
            this.errorMsg = true;
            this.serverError$.subscribe((data) => {
              this.confirmMsg = data;
              this.message = this.confirmMsg;
            });
            this.showAlertBox();
          } catch (error) {}
        }
      );
  }

  changeCategory(item, categoryIndex) {
    this.changeCategoryRef = this.dialog.open(ChangeCategoryComponent, {
      data: {
        serviceId: this.serviceId,
        termId: item?.id?.value,
      },
    });
    this.changeCategoryRef.afterClosed().subscribe((results) => {
      if (results?.category) {
        this.store
          .dispatch(
            new ChangeTermCategory(results.termId, {
              category: results.category,
            })
          )
          .subscribe((data) => {
            this.store.dispatch(new GetServiceById(this.serviceId));
          });
      }
    });
  }

  editIndexation(
    item,
    termId,
    unitMeasurement,
    categoryIndex,
    termIndex,
    indexationIndex
  ) {
    this.editIndexationRef = this.dialog.open(IndexationComponent, {
      data: {
        indexationItem: item,
        termId: termId,
        unitMeasurement: unitMeasurement,
      },
    });
    this.editIndexationRef.afterClosed().subscribe((results) => {
      if (results) {
        let indexationItem =
          this.serviceDetails.categories[categoryIndex].terms[termIndex]
            .indexations[indexationIndex];
        indexationItem.description = results.description;
        indexationItem.name = results.name;
        indexationItem.is_default = results.is_default;
        indexationItem.unit_cost = results.unit_cost;
        indexationItem.unit_of_measurement = results.unit_of_measurement;
      }
    });
  }

  save(event?) {
    if (this.isValidExcept(this.addServiceFormGroup, ['categories'])) {
      this.alertmsg = false;
      this.store.dispatch(new HandleError(''));
      const serviceObj = {
        name: this.addServiceFormGroup.get('name').value,
        explantion_txt: this.addServiceFormGroup.get('explantion_txt').value,
        order_pool_delay_minutes: this.addServiceFormGroup.get('order_pool_delay_minutes').value,
        is_active: this.addServiceFormGroup.get('is_active').value,
        show_terms: this.addServiceFormGroup.get('show_terms').value,
        completion_status:
          this.addServiceFormGroup.get('completion_status').value,
        building_data_to_show: this.addServiceFormGroup.get(
          'building_data_to_show'
        ).value,
        service_credentials: this.addServiceFormGroup.get('service_credentials')
          .value,
        default_notes_display: this.addServiceFormGroup.get('default_notes_display').value
      };
      
      if (this.isActiveExsep != null) {
        serviceObj['is_active_for_exsep'] = this.addServiceFormGroup.get(
          'is_active_for_exsep'
        ).value;
      }

      if (!this.addStatus) {
        this.store
          .dispatch(
            new UpdateService(this.serviceId, serviceObj, event?.buttonId)
          )
          .subscribe(
            (data) => {
              this.successImg = true;
              this.confirmMsg = 'تم الحفظ بنجاح';
              this.showAlertBox();
            }
          );
      } else {
        this.store.dispatch(new AddService(serviceObj)).subscribe(
          (data) => {
            let serviceId = data.NewServicesState.serviceById.id;
            this.successImg = true;
            this.confirmMsg = 'تم الحفظ بنجاح';
            this.showAlertBox();
            this.router.navigate([`pages/services/edit/${serviceId}`], {
              replaceUrl: true,
            });
          }
        );
      }
    } else {
      this.alertmsg = true;
      this.message = 'برجاء تعبئة  جميع الخانات ';
    }
  }

  getServiceById() {
    this.serviceByIdSubscribtion = this.serviceById$.subscribe(
      (data) => {
        if (data?.id && data?.id == +this.serviceId) {
          let categoriesArr = <FormArray>(
            this.addServiceFormGroup.controls['categories']
          );
          categoriesArr.clear();
          this.serviceDetails = data;
          this.initBuildingDetails = this.serviceDetails.building_data_to_show;
          this.initAdditions = this.serviceDetails.additions;
          this.isActive = this.serviceDetails.is_active;
          this.isActiveExsep = this.serviceDetails.is_active_for_exsep;
          this.allow_inspector_to_skip_terms =
            this.serviceDetails.allow_inspector_to_skip_terms;
          this.is_droplist = this.serviceDetails.is_droplist;
          this.addServiceFormGroup.patchValue({
            name: this.serviceDetails.name,
            explantion_txt: this.serviceDetails.explantion_txt,
            order_pool_delay_minutes: this.serviceDetails.order_pool_delay_minutes,
            is_active: this.serviceDetails.is_active,
            is_active_for_exsep: this.serviceDetails.is_active_for_exsep,
            allow_inspector_to_skip_terms:
              this.serviceDetails.allow_inspector_to_skip_terms,
            is_droplist: this.serviceDetails.is_droplist,
            show_terms: this.serviceDetails.show_terms,
            completion_status: this.serviceDetails.completion_status,
            building_data_to_show: this.serviceDetails.building_data_to_show,
            additions: this.serviceDetails.additions,
            service_credentials: this.serviceDetails.service_credentials,
            default_notes_display: this.serviceDetails.default_notes_display,
          });
          this.serviceDetails?.categories?.forEach((element, index) => {
            this.addCategory();
            this.categories().at(index).get('name').setValue(element.name);
            this.categories().at(index).get('id').setValue(element.id);
            this.categories().at(index).get('ratio').setValue(element.ratio);
            this.pushTermsData(index);
          });
          if (!this.statusCustomChoices.find((status => status.id === this.serviceDetails.completion_status))) {
            this.getCompleltionStatusById(this.serviceDetails.completion_status);
          }
        } else {
          this.store.dispatch(new GetServiceById(this.serviceId));
        }
      },
      (error) => {
        try {
        } catch {}
      }
    );
  }

  getCompleltionStatusById(selected: any) {
    const id = typeof selected === 'number' ? selected : selected?.id;
    if (!id) {
      this.ratingChoices = [];
      this.showRatingPanel = false;
      return;
    }

    this.showRatingPanel = false;
    this.dynamicService.getStatusCustomById(id).subscribe((data: any) => {
      this.ratingChoices = data?.choices || [];
    });
  }

  pushTermsData(categoryIndex) {
    if (this.serviceDetails?.categories[categoryIndex].terms.length == 0) {
      this.addItem(categoryIndex);
    } else {
      this.serviceDetails?.categories[categoryIndex].terms.forEach(
        (element, index) => {
          this.addItem(categoryIndex);
          this.terms(categoryIndex).at(index).get('id').setValue(element.id);
          this.terms(categoryIndex)
            .at(index)
            .get('name')
            .setValue(element.name);
          this.terms(categoryIndex)
            .at(index)
            .get('description')
            .setValue(element.description);
          this.terms(categoryIndex)
            .at(index)
            .get('ratio')
            .setValue(element.ratio);

          this.terms(categoryIndex)
            .at(index)
            .get('is_decision_driver')
            .setValue(element.is_decision_driver ?? false);
        }
      );
    }
  }

  showAlertBox() {
    this.saveDialogRef = this.dialog.open(AlertBoxComponent, {
      data: {
        imgSuccess: this.successImg,
        message: this.confirmMsg,
        button: 'تم',
      },
    });
  }

  updateCategories() {
    this.addCategoryRef = this.dialog.open(AddCategoriesComponent, {
      data: this.serviceDetails?.categories,
    });
    this.addCategoryRef.afterClosed().subscribe((result) => {
      if (result) {
        this.store.dispatch(
          new ChangeCategoriesRatio(this.serviceId, result.categories)
        );
      }
    });
  }

  closeError() {
    this.alertmsg = false;
  }

  goBack() {
    this.router.navigateByUrl('pages/services/list');
  }

  goToSettings() {
    this.router.navigateByUrl(`pages/services/settings/${this.serviceId}`);
  }

  getDynamicServicesChoices() {
    this.dynamicService.getDynamicServicesChoices().subscribe(
      (data) => {
        data['show_choices'].map((item) => {
          this.choicesList.push({ id: item[0], name: item[1] });
        });
      },
      (error) => {
        try {
        } catch {}
      }
    );
  }

  getBuildingData() {
    this.dynamicService.getBuildingData().subscribe((data) => {
      this.buildingDetails = data;
    });
  }

  getNotesDisplayChoices() {
    this.dynamicService.getNotesDisplayChoices().subscribe((data: any) => {
      this.notesDisplayChoices = data;
    });
  }

  setBuildingDetails(event) {
    this.addServiceFormGroup.controls.building_data_to_show.patchValue([
      ...event,
    ]);
  }

  getStatusCustomDisplay() {
    this.status_payload = {
      page: this.status_config?.currentPage,
      query: '',
      page_size: this.status_config?.itemsPerPage,
    };
    this.dynamicService
      .getStatusCustomDisplay(this.status_payload)
      .subscribe((data) => {
        data['results'].forEach(item => {
          if (!this.statusCustomChoices.some(x => x.id === item.id)) {
            this.statusCustomChoices.push(item);
          }
        });
        this.status_config['totalItems'] = data['count'];
        this.status_config['page_count'] = data['pages_count'];
      });
  }

  onScrollCustomChoicesPagination() {
    if (this.status_config.currentPage < this.status_config.page_count) {
      this.status_config.currentPage++;
      this.getStatusCustomDisplay();
    }
  }

  toggleRatingPanel() {
    if (this.ratingChoices.length > 0) {
      this.showRatingPanel = !this.showRatingPanel;
    }
  }



  openServiceCredentials() {
    this.credentialsDialogRef = this.dialog.open(ServiceCredentialsComponent, {
      data: this.serviceDetails.service_credentials,
    });
    this.credentialsDialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.addServiceFormGroup.get('service_credentials').setValue(result);
        this.save();
      }
    });
  }

  redistrebuteRatios() {
    this.confirmationDialogRef = this.dialog.open(ConfirmationBoxComponent, {
      data: {
        message: 'هل انت متأكد من اعادة توزيع النسب اتوماتيكيا؟',
        confirmBtn: 'موافق',
      },
    });
    this.confirmationDialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.store.dispatch(new RedistrbuteRatios(this.serviceId));
      }
    });
  }

  addCompletionStatus() {
    this.statusRef = this.dialog.open(CompletionStatusComponent, {
      data: {
        label: 'اسم نوع التقييم',
        placeholder: 'مثال: حالة العنصر',
        textValue: '',
      },
      width: '808px',
      maxWidth: '90vw',
    });
    this.statusRef.afterClosed().subscribe((results) => {
      if (results?.choices) {
        const filteredChoices = results.choices.filter(choice =>
          Object.values(choice).some(value => value !== null && value !== '')
        );

        if(filteredChoices.length > 0) {
          results.choices = filteredChoices;
          this.settingServices.addStatus(results).subscribe((data) => {
            const createdStatusId = data?.id ?? data?.results?.id ?? data?.data?.id;
            const createdStatusName = data?.name ?? data?.results?.name ?? data?.data?.name ?? results?.name;

            if (createdStatusId) {
              if (!this.statusCustomChoices.some((status: any) => status.id === createdStatusId)) {
                this.statusCustomChoices.unshift({
                  id: createdStatusId,
                  name: createdStatusName,
                });
              }

              this.addServiceFormGroup.get('completion_status')?.setValue(createdStatusId);
              this.getCompleltionStatusById(createdStatusId);
            }

            this.status_payload.page = 1;
            this.status_config.currentPage = this.status_payload.page;
            this.getStatusCustomDisplay();
          }, (error) => {
            this.successImg = false;
            this.confirmMsg = error.error.choices ? error.error.choices.join(',') :  'حدث خطأ ما، يرجى المحاولة مرة أخرى';
            this.showAlertBox();
          });
        };
      }
    });
  }

  getunitMeasurments(params) {
    this.settingServices.getUnitOfMeasurements(params).subscribe((data) => {
      this.unitMeasurments.push(...data.results);
    });
  }

  onScrollPagination() {
    if (this.measurementPage < this.measurement_page_count) {
      this.measurementPage++;
      this.measurementParams = { page: this.measurementPage };
      this.getunitMeasurments(this.measurementParams);
    }
  }

  getTermUniqueIndex(categoryIndex: number, termIndex: number): number {
    return categoryIndex * 1000 + termIndex;
  }

  areTermsValid(categoryIndex: number): boolean {
    const termsArray = this.terms(categoryIndex);
    for (let i = 0; i < termsArray.length; i++) {
      const term = termsArray.at(i);
      if (
        term.get('name').invalid ||
        term.get('description').invalid ||
        term.get('ratio').invalid ||
        term.get('repairing_cost').invalid
      ) {
        return false;
      }
    }
    return true;
  }
}
